import { CollectionItem } from '@aipb/gulliver/personal-content/model';
import { getCollectionLabel } from '@aipb/gulliver/personal-content/util';
import { UiImageModule } from '@aipb/shared/ui/image';

import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'pc-shared-collection-label',
  templateUrl: './collection-label.component.html',
  styleUrls: ['./collection-label.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [UiImageModule, TranslocoModule]
})
export class CollectionLabelComponent {
  private _collection: CollectionItem;

  get collection() {
    return this._collection;
  }

  @Input() set collection(value: CollectionItem) {
    this._collection = value;
    this._label = this.initLabel();
  }

  private _label: string;

  get label() {
    return this._label;
  }

  private initLabel(): string {
    return getCollectionLabel(this._collection);
  }
}
